import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectToLegalEntitiesPage = () => {
  const { navigation } = useNavigation()

  return <Navigate to={navigation.settings.it_inventory.legalEntities.fullPath()} replace />
}

export default RedirectToLegalEntitiesPage
